import Box from '@mui/material/Box'
import { styled } from '@mui/system'
import type { Theme } from '@mui/material/styles'
import { blue, grey, shade, green, yellow } from '../../../colors'
import { Button, Chip, IconButton } from '@mui/material'

// Function to return color based on status
const getStatusIndicatorColor = (status: string): string => {
  switch (status) {
    case 'test-classranked':
      return 'green'
    case 'dev-classranked':
      return 'orange'
    default:
      return 'gray'
  }
}

const getChipColor = (status: string): string => {
  switch (status) {
    case 'test-classranked':
      return green[0]
    case 'dev-classranked':
      return yellow[100]
    default:
      return grey[50]
  }
}
interface StyledChipProps {
  status: string
  theme?: Theme
}

// Styled Chip
export const StyledChip = styled(Chip)<StyledChipProps>(({ status, theme }) => ({
  backgroundColor: getChipColor(status),
  fontSize: theme.spacing(4),
  padding: `${theme.spacing(2.5)} ${theme.spacing(3.5)}`,
  borderRadius: theme.spacing(2),
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}))

interface StatusIndicatorProps {
  status: string
  theme?: Theme
}
// Styled Box for status dot
export const StatusIndicator = styled(Box)<StatusIndicatorProps>(({ status, theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  borderRadius: '50%',
  backgroundColor: getStatusIndicatorColor(status)
}))

interface DivProps {
  isMobile: boolean
  theme?: Theme
}

export const Div = styled(Box)<DivProps>(({ theme, isMobile }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  paddingRight: isMobile ? theme.spacing(0.5) : theme.spacing(3.75)
}))

interface StyledLinkProps {
  isTablet: boolean
  isMobile: boolean
  theme?: Theme
  active?: boolean | null
}

export const StyledLink = styled(Button)<StyledLinkProps>(({ theme, active, isMobile }) => ({
  color: (active ?? false) ? blue[500] : grey[50],
  textTransform: 'capitalize',
  background: active ? shade[1] : 'transparent',
  fontWeight: isMobile ? 'unset' : 'bold',
  cursor: 'pointer',
  letterSpacing: '1%',
  position: 'relative',
  fontSize: isMobile ? theme.spacing(3) : theme.spacing(4),
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  transition: '.3s',
  borderRadius: `${theme.spacing(2)}`,

  '&:hover': {
    background: blue[100],
    color: theme.palette.primary.main

  }

}))

export const ActivityMonitorIcon = styled(IconButton)(({ theme }) => ({
  color: grey[50],
  borderRadius: `${theme.spacing(3)}`, // Square border
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,

  // Remove ripple effect
  '& .MuiTouchRipple-root': {
    display: 'none'
  },

  '&:hover': {
    background: blue[100],
    color: theme.palette.primary.main
  }
}))
